<template>
    <div class="app-nav-panel" :class="{'open': isOpen}">
        <div class="overlay visible-xs hidden-md" @click="closeNav()"></div>
        <div class="content-wrap">
            <div class="brand-section">
                <div class="logo">
                    <img v-if="isDarkMode" src="./../assets/images/logo-alt.svg">
                    <img v-else src="./../assets/images/logo.svg">
                </div>
            </div>
            <div class="devider special"></div>
            <div class="nav-section">
                <div class="nav-list">
                    <router-link class="nav-item" to="/">
                        <span class="icon">
                            <span class="fas fa-columns"></span>
                        </span>
                        <span class="text">Dashboard</span>
                    </router-link>
                    <router-link class="nav-item" to="/projects">
                        <span class="icon">
                            <span class="fas fa-stream"></span>
                        </span>
                        <span class="text">Projects</span>
                    </router-link>
                    <router-link class="nav-item" to="/datastorage" v-if="this.user.role != 'user'">
                        <span class="icon">
                            <span class="fas fa-database"></span>
                        </span>
                        <span class="text">Data storage</span>
                    </router-link>
                    <router-link class="nav-item" to="/friends">
                        <span class="icon">
                            <span class="fas fa-user-friends"></span>
                        </span>
                        <span class="text">Friends</span>
                    </router-link>
                </div>
            </div>
            <div class="nav-section">
                <p class="nav-title">Information</p>
                <div class="nav-list">
                    <router-link class="nav-item" to="/documentation">
                        <span class="icon">
                            <span class="fas fa-book"></span>
                        </span>
                        <span class="text">Documentation</span>
                    </router-link>
                    <a class="nav-item" href="https://about.ionds.app" target="_blank">
                        <span class="icon">
                            <span class="fas fa-info"></span>
                        </span>
                        <span class="text">About app</span>
                    </a>
                </div>
            </div>
            <!-- <div class="nav-section">
                <p class="nav-title">Account</p>
                <div class="nav-list">
                    <router-link class="nav-item" to="/profile">
                        <span class="icon">
                            <span class="fas fa-user"></span>
                        </span>
                        <span class="text">Profile</span>
                    </router-link>
                    <router-link class="nav-item" to="/settings">
                        <span class="icon">
                            <span class="fas fa-cogs"></span>
                        </span>
                        <span class="text">Settings</span>
                    </router-link>
                </div>
            </div> -->
            <div class="nav-section" v-if="user.role == 'admin' || user.role == 'master'">
                <p class="nav-title">Admin settings</p>
                <div class="nav-list">
                    <router-link class="nav-item" to="/users">
                        <span class="icon">
                            <span class="fas fa-users"></span>
                        </span>
                        <span class="text">Users</span>
                    </router-link>
                    <router-link class="nav-item" to="/logs">
                        <span class="icon">
                            <span class="fas fa-chart-bar"></span>
                        </span>
                        <span class="text">Logs</span>
                    </router-link>
                </div>
            </div>
            <div class="user-box-section">
                <div class="user-box">
                    <router-link class="user" to="/profile">
                        <div class="avatar">
                            <img v-if="user.avatarUrl.length" :src="user.avatarUrl">
                            <img v-else src="./../assets/images/user.png">
                            <span class="role">{{ user.role }}</span>
                        </div>
                        <div class="info">
                            <p class="name">{{ user.bio.name || 'No name' }}</p>
                            <p class="email">{{ user.email || '-' }}</p>
                        </div>
                    </router-link>
                    <div class="actions">
                        <router-link to="/settings">
                            <span class="fas fa-cog"></span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['isOpen'],
    computed: {
        isDarkMode() {
            return this.$store.getters['isDarkMode'];
        },
        user() {
            return this.$store.getters['getUser'];  
        }
    },
    methods: {
        closeNav() {
            this.$emit('closeNav', false)
        }
    },
    watch: {
        '$route': function () {
            this.closeNav();
        }
    }
}
</script>
